import {AxiosInstance} from "axios";
import {LoyaltyCardMembershipTransaction} from "@/loyalty-card/interfaces/hds/LoyaltyCard";
import {PaginatedData} from "@/core/interfaces/api";

/**
 * The loyalty card membership transaction resource.
 * @author Tony Laurent <t.laurent@apodispharma.com>
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Get all loyalty card membership transactions.
         * @param {number} customerId - The ID of the customer.
         * @param {number} membershipId - The ID of the membership.
         * @param {string} type - The transactions type.
         * @param {number} [page] - The page number.
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async get(
            customerId: number,
            membershipId: number,
            type?: string | null,
            page?: number
        ): Promise<PaginatedData<LoyaltyCardMembershipTransaction[]>> {
            return client
                .get(`/customers/${customerId}/loyalty-card-memberships/${membershipId}/transactions`, {
                    params: {
                        type,
                        page
                    }
                })
                .then(response => response.data)
                .catch(() => []);
        }
    };
}
